export const VALIDATION = {
    requiredField: 'Обязательное поле',
    doesNotMatchRegExp: 'Неверный формат данных'
}
